import React from 'react'
import { useTranslation } from 'react-i18next'

import RegionsFilter from './RegionsFilter'
import StakeholderFilter from './StakeholderFilter'

import { useSroiReportVisibility } from '../hooks/useSroiReportVisibility'

import useStyles from './styles'
import { helpTexts } from '../constants'
import HoverHelpTextIcon from '../../../../features/components/HoverHelpTextIcon'

const ReportFilters = () => {
  const { t } = useTranslation()
  const classes = useStyles()

  const { hasMultipleRegions, hasMultipleStakeholders } = useSroiReportVisibility()

  const hasFiltersToShow = hasMultipleRegions || hasMultipleStakeholders

  if (!hasFiltersToShow) {
    return null
  }

  return (
    <div className={classes.reportFiltersContainer}>
      <div className={classes.reportFiltersLabel}>
        {t('Filter report')} <HoverHelpTextIcon helpText={helpTexts.filterReport} />
      </div>
      <div className={classes.filters}>
        {hasMultipleRegions && <RegionsFilter />}
        {hasMultipleStakeholders && <StakeholderFilter />}
      </div>
    </div>
  )
}

export default ReportFilters
